import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath, ToggleRevealItemContext, useToggleRevealItem } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var accordionItemVariantPath = getVariantPath({
  id: 'accordion',
  element: 'accordionItem'
})();
var AccordionItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ["children", "open", "onOpen", "onClose"]);

  var _useToggleRevealItem = useToggleRevealItem({
    onOpen: onOpen,
    onClose: onClose,
    open: open
  }),
      extToggleOpen = _useToggleRevealItem.extToggleOpen,
      isOpen = _useToggleRevealItem.isOpen;

  return _jsx("div", _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: accordionItemVariantPath
    }
  }, props), {}, {
    children: _jsx(ToggleRevealItemContext.Provider, {
      value: {
        isOpen: isOpen,
        handleToggle: extToggleOpen
      },
      children: children
    })
  }));
});
AccordionItem.displayName = 'AccordionItem';
AccordionItem.propTypes = {
  /**
   * The initial state for the accordion item
   */
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
AccordionItem.defaultProps = {
  open: false
};
export { AccordionItem };